export const APP_NAME = "Intechlinks";
export const DEFAULT_PER_PAGE = 20;
export const EXCHANGE_RATE_BUFFER = 0;
export const INVOICE_NO_PREFIX = "INT";
export const DEFAULT_START_DATE = "2023-01-01";
export const APP_VERSION = "1.0.7";
